import { Area, Bedrooms, Close, Flag, NotFoundFavorites, RedMapPin, RedTrash, Trash } from 'assets/images/web-isn';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { bindActionCreators } from 'redux';
import { ICON_LEFT, ICON_RIGHT } from 'utils/constants';
import { formatMoney } from 'utils/objects';
import { SubMenuAccountComponent } from '../common';
import OwlCarousel from 'react-owl-carousel2';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getQueryString } from 'utils/params';
import { getFavoritesAccount, postRemoveFavorites } from '../accountPage.api';
import ReactPaginate from 'react-paginate';
import previousIcon from '../../../assets/images/arrow-left.png';
import nextIcon from '../../../assets/images/arrow-right.png';
import { Modal } from 'react-bootstrap';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';

function FavouritesComponent(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { currentCurrency } = props.layout;
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { language } = useParams();
  const [favorData, setFavorData] = useState([]);
  let listData = [];
  const [listIdSelectAll, setListIdSelectAll] = useState([]);
  const searchParams = new URLSearchParams(useLocation().search);
  const [pageCount, setPageCount] = useState();
  const pageSize = 15;
  const [pageIndex, setPageIndex] = useState(searchParams.get('pageIndex'));
  const [forcePage, setForcePage] = useState(searchParams.get('pageIndex') - 1);
  const [selectAll, setSelectAll] = useState(false);
  const [show, setShow] = useState(false);
  const [listApartment, setListApartment] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const option = {
    items: 1,
    autoplay: false,
    loop: false,
    dots: true,
    nav: true,
    navText: [ICON_LEFT, ICON_RIGHT],
    autoHeight: true,
    responsive: {},
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    center: true,
  };

  useEffect(() => {
    fetchFavorites();
    //eslint-disable-next-line
  }, [pageIndex]);

  const [isShowLoader, setIsShowLoader] = useState(false);

  const fetchFavorites = () => {
    showLoader();
    setIsShowLoader(true);
    getFavoritesAccount(getQueryString({ language, pageSize: pageSize, pageIndex: pageIndex })).then(res => {
      if (res?.data) {
        const newList = [];
        if (res.data?.items) {
          res.data.items.forEach(item => {
            newList.push(item.apartmentId);
          });
          setListApartment(newList.sort());
        }
        setFavorData(res.data);
        setPageCount(Math.ceil(res?.data?.totalRecords / pageSize));
      }
      hideLoader();
      setIsShowLoader(false);
    });
  };

  const handleSelect = apartmentId => {
    if (listIdSelectAll && listIdSelectAll.includes(apartmentId)) {
      listData = listIdSelectAll.filter(i => i !== apartmentId);
      setListIdSelectAll(listData);
      if (selectAll === true) {
        setSelectAll(!selectAll);
      }
    } else {
      listData = [...listIdSelectAll, apartmentId];
      setListIdSelectAll(listData);

      let equals = listData.length === listApartment.length && listData.sort().every((e, i) => e === listApartment[i]);
      if (equals === true) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  };

  const handleRemove = () => {
    if (listIdSelectAll.length > 0) {
      showLoader();
      postRemoveFavorites(getQueryString({ listApartment: listIdSelectAll.join(',') })).then(res => {
        if (res === true) {
          fetchFavorites();
          setSelectAll(false);
          handleClose();
          setListIdSelectAll([]);
        } else return;
        hideLoader();
      });
    } else return;
  };

  const changePage = ({ selected }) => {
    setForcePage(selected);
    setPageIndex(selected + 1);
    searchParams.set('pageIndex', selected + 1);
    history.push({ pathname: location.pathname, search: searchParams.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSelectAll = e => {
    const isChecked = e.target.checked;
    setSelectAll(!selectAll);

    if (isChecked === true) {
      if (favorData?.items?.length > 0) {
        const listId = [];
        favorData.items.forEach(item => {
          listId.push(item.apartmentId);
        });

        setListIdSelectAll(listId);
      }
    } else {
      setListIdSelectAll([]);
    }
  };

  return (
    <>
      <SubMenuAccountComponent />
      <div id="favourites" className="container">
        {(favorData.items === null || favorData.length === 0) && isShowLoader === false ? (
          <>
            <div className="favourites-notFound">
              <img src={NotFoundFavorites} alt="icon-not-found" />
              <div className="favourites-notFound_desc">{t('manageAccount.label_noFoundFavourites')}</div>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex">
              <label className="favourites-checkbox mb-0 mr-3">
                <div className="favourites-checkbox_text">{t('manageAccount.label_selectAll')}</div>
                <input type="checkbox" onChange={e => handleSelectAll(e)} checked={selectAll} />
                <span className="checkmark"></span>
              </label>

              <div
                className="favourites-trash d-flex align-items-center ml-3"
                onClick={listIdSelectAll.length > 0 ? handleShow : null}
              >
                <img src={Trash} alt="trash-icon" />
                <span>{t('manageAccount.label_CLEAR')}</span>
              </div>
            </div>
            <div className="row">
              {favorData.items === null
                ? ''
                : favorData.items?.map((item, index) => {
                    return (
                      <div id="serviceApartment" className="p-3 col-xl-4 col-md-6 col-sm-12 col-12" key={index}>
                        <div className="project-info justify-content-center align-items-center mt-1">
                          <div className="container-slider">
                            <OwlCarousel options={option}>
                              {item.images.map((sliderImage, i) => {
                                return (
                                  <div className="slide" key={i}>
                                    <Link
                                      to={`/${language}/serviced-apartments/overview/${item.id}/${item.slug}/${item.typeCode}`}
                                    >
                                      <LazyLoadImage
                                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${sliderImage.url}`}
                                        alt=""
                                      />
                                    </Link>
                                  </div>
                                );
                              })}
                            </OwlCarousel>
                          </div>
                          <div className="select-contents">
                            <label className="favourites-checkbox">
                              <input
                                type="checkbox"
                                value={item.apartmentId}
                                checked={listIdSelectAll.length && listIdSelectAll.includes(item.apartmentId)}
                                onChange={() => handleSelect(item.apartmentId)}
                              />
                              <span className="checkmark select-check"></span>
                            </label>
                          </div>
                          <div
                            className="content"
                            onClick={() =>
                              history.push(
                                `/${language}/serviced-apartments/overview/${item.id}/${item.slug}/${item.typeCode}`,
                              )
                            }
                          >
                            <div className="project-name">{item.name}</div>
                            {item.address ? (
                              <div className="apartment-address mt-2">
                                <img src={Flag} alt="flag without f" />
                                <div className="address-description ml-1">{item.address}</div>
                              </div>
                            ) : (
                              ''
                            )}
                            <div className="apartment-infomation d-flex mt-3 flex-column">
                              <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                  <img src={RedMapPin} alt="location" />
                                  <div className="project-location ml-1">{item.district}</div>
                                </div>
                                <div className="bedroom-size d-flex">
                                  <img src={Bedrooms} alt="bedrooms" />
                                  <div className="project-bed">
                                    {item.bedRoomName ? <span>&nbsp;{item.bedRoomName}</span> : ''}
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between">
                                <div className="mt-2">
                                  <div className="project-price">
                                    <span className="focus-price">
                                      {currentCurrency?.code === 'USD' && item.priceOffer && item.isOffer === true
                                        ? `${currentCurrency?.symbol}${formatMoney(item.priceOffer, 0, 0)}`
                                        : ''}
                                      {currentCurrency?.code === 'USD' &&
                                      item.price &&
                                      (item.isOffer === false || (item.isOffer && !item.priceOffer))
                                        ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                        : ''}
                                      {currentCurrency?.code === 'VND' && item.priceOfferVi && item.isOffer === true
                                        ? `${formatMoney(item.priceOfferVi, 0, 0)}${currentCurrency?.symbol}`
                                        : ''}
                                      {currentCurrency?.code === 'VND' &&
                                      item.priceVi &&
                                      (item.isOffer === false || (item.isOffer && !item.priceOfferVi))
                                        ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                        : ''}
                                    </span>
                                    /
                                    {item.typeCode === 'long' ? (
                                      <span>{t('service_apartment_isn.label_month')}</span>
                                    ) : (
                                      <span>{t('service_apartment_isn.label_day')}</span>
                                    )}
                                  </div>
                                  <div className="project-price" style={{ color: '#6b6b6b' }}>
                                    <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                                      {currentCurrency?.code === 'USD' && item.isOffer === true && item.priceOffer > 0
                                        ? `${currentCurrency?.symbol}${formatMoney(item.price, 0, 0)}`
                                        : ''}
                                      {currentCurrency?.code === 'VND' && item.isOffer === true && item.priceOfferVi > 0
                                        ? `${formatMoney(item.priceVi, 0, 0)}${currentCurrency?.symbol}`
                                        : ''}
                                    </span>
                                    {item.typeCode === 'long' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                      <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_month')}</span>
                                    ) : (
                                      ''
                                    )}
                                    {item.typeCode === 'short' && item.priceOffer > 0 && item.priceOfferVi > 0 ? (
                                      <span style={{ textDecoration: 'line-through' }}>/{t('offers.label_day')}</span>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                                <div className="apartment-area d-flex mt-2">
                                  <img src={Area} alt="area" />
                                  <div className="project-area">
                                    {item.size ? `${item.size}` : ''}
                                      <React.Fragment>
                                        m<sup>2</sup>
                                      </React.Fragment>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
            {/* paginate */}
            {favorData && favorData.totalRecords > 15 ? (
              <div className="service-paginate">
                <ReactPaginate
                  previousLabel={<LazyLoadImage src={previousIcon} alt="nav-btn" />}
                  nextLabel={<LazyLoadImage src={nextIcon} alt="nav-btn" />}
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  onPageChange={changePage}
                  disabledClassName={'opacity-disable'}
                  activeClassName={'pagination-active'}
                  pageClassName={'pagination-pager-item'}
                  nextLinkClassName={'next-btn'}
                  previousLinkClassName={'prev-btn'}
                  forcePage={forcePage}
                />
              </div>
            ) : (
              <div className="mt-5"></div>
            )}{' '}
          </>
        )}
      </div>

      <Modal id="removeFavoritesModal" centered show={show} onHide={handleClose} backdrop="static">
        <div className="close-btn" onClick={handleClose}>
          <img src={Close} alt="close-icon" />
        </div>
        <div className="remove-favorites">
          <div className="remove-favorites_trash-icon">
            <img src={RedTrash} alt="red-trash-icon" />
          </div>
          <div className="remove-favorites_title">{t('manageAccount.label_removeTitle')}</div>
          <div className="remove-favorites_desc">{t('manageAccount.label_removeDesc')}</div>
        </div>
        <div className="d-flex justify-content-center remove-favorites_button">
          <input
            type="button"
            value={t('manageAccount.label_no')}
            className="remove-favorites_button-no"
            onClick={handleClose}
          />
          <input
            type="button"
            value={t('manageAccount.label_yes')}
            className="remove-favorites_button-yes"
            onClick={handleRemove}
          />
        </div>
      </Modal>
      {loader}
    </>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(FavouritesComponent);
